import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties } from "react";
import Lottie from "react-lottie";
import Heading from "src/components/Heading";
import Translate from "src/components/Translate";
import constants from "src/constants";
import * as lottieBenefit from "src/icons/Lottie-benefit.json";
import * as lottieTaskList from "src/icons/Lottie-task-list.json";
import * as lottieYoga2 from "src/icons/Lottie-yoga-2.json";
import { sGroupTitle } from "src/styles/sGroupTitle.module.scss";
import { sPlatformCard } from "src/styles/sPlatformCard.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
};

function PlatformCardsCompanies({ style, className }: Props) {
  return (
    <div
      className={composeClassNames([
        sPlatformCard,
        className,
        "platform-cards",
      ])}
      style={style}
    >
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieTaskList,
            }}
            width={300}
            height={300}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Productivity and energy`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`Mental or physical exercise during a work break or lunch break significantly increases productivity and strengthens the mind and body.`}
            />
          </p>
        </div>
      </div>
      <div className="platform-card">
        <div
          className="platform-card-lottie"
          style={{ marginTop: constants.Size.xl }}
        >
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieBenefit,
            }}
            width={300}
            height={260}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`Employee benefits`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`Meaningful employee benefits that benefit health and overall satisfaction.`}
            />
          </p>
        </div>
      </div>
      <div className="platform-card">
        <div className="platform-card-lottie">
          <Lottie
            options={{
              ...constants.Images.lottieDefaultOptions,
              animationData: lottieYoga2,
            }}
            width={300}
            height={300}
          />
        </div>
        <div className="platform-card-text">
          <Heading
            type="h3"
            title={<Translate tKey={`The right thing for everyone`} />}
            className={composeClassNames([sGroupTitle, "platform-card-title"])}
          />
          <p>
            <Translate
              tKey={`An extensive library of online classes and series with different lengths, topics and types of exercises offers the right thing for each of your employees.`}
            />
          </p>
        </div>
      </div>
    </div>
  );
}

export default PlatformCardsCompanies;
